import { Renderer } from "@omegagrid/grid";
import { ReportResult } from "../../../model";
import { IndicatorRenderer, ReportContext } from "@reporting/rp-types/analytics";
import { createWaterfallRenderer } from "./waterfallRenderer";
import { createDatabarRenderer } from "./databarRenderer";
import { createLollipopRenderer } from "./lollipopRenderer";

export type RendererType = IndicatorRenderer;

export const rendererTypes: {k: RendererType, v: string}[] = [
	{k: 'value', v: 'Value'},
	{k: 'databar', v: 'Data Bar'},
	{k: 'datacolumn', v: 'Data Column'},
	{k: 'waterfall', v: 'Waterfall'},
	{k: 'lollipop', v: 'Lollipop'},
];

export type CreateCellRendererOptions = {
	context: ReportContext;
	reportResult: ReportResult;
	scope: 'global'|'column'|'row',
	direction: 'row'|'column',
	firstIndex: number // index of the first row or column
};

export function createCellRenderer(type: RendererType, opt: CreateCellRendererOptions): Renderer {
	if (type === 'databar') return createDatabarRenderer(opt);
	if (type === 'waterfall') return createWaterfallRenderer(opt);
	if (type === 'lollipop') return createLollipopRenderer(opt);
	return null;
}
